import { render, staticRenderFns } from "./ershoufang.vue?vue&type=template&id=226c3888&scoped=true&"
import script from "./ershoufang.vue?vue&type=script&lang=js&"
export * from "./ershoufang.vue?vue&type=script&lang=js&"
import style0 from "./ershoufang.vue?vue&type=style&index=0&id=226c3888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c3888",
  null
  
)

export default component.exports